import Decimal from 'decimal.js';

/**
 * إعداد موحّد لحساب الأرقام العشرية.
 *
 * precision = 40 خانة داخلية: أكثر بكثير من أي مبلغ مالي واقعي، فلا يحدث فقدان دقة
 * في العمليات المتسلسلة (TotalOrders × OrderRate ثم الجمع ثم الطرح).
 * التقريب الافتراضي = ROUND_HALF_UP، ويُطبَّق صريحاً عند إخراج أي مبلغ.
 */
Decimal.set({
  precision: 40,
  rounding: Decimal.ROUND_HALF_UP,
  toExpNeg: -30,
  toExpPos: 40,
  minE: -9e15,
  maxE: 9e15,
});

export { Decimal };
export type DecimalValue = Decimal.Value;
